<template>
  <div class="procedures">
    <procedures-page object="expertise" />
  </div>
</template>

<script>
import ProceduresPage from '@/components/procedures/procedures-page'

export default {
  components: {
    ProceduresPage
  }
}
</script>

<style></style>
